module.exports = __webpack_public_path__ + "static/media/feedback.697c9b06.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/lifedash/src/feedback.mov
// module id = 208
// module chunks = 0